'use strict';

import React from 'react';
import I18n from '../config/translations';

const API_PLACE_DETAILS_URL = '/api/places/details';
const STATE_SET = 'State.set';
const COUNTRY_SET = 'Country.set';
const CENTER_SET = 'Center.set';

export default class AutocompleteItem extends React.Component {
  handleClick = (e) => {
    this.props.handleItemClick(this.props.text);
    this.callApiToGetPlaceDetails();
  }

  callApiToGetPlaceDetails() {
    var language = this.props.language;
    fetch(`${API_PLACE_DETAILS_URL}?place_id=${this.props.placeId}&language=${language}`, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Cookie': 'locale=' + I18n.locale,
      },
    })
      .then(this.handleResponse);
  }

  handleResponse = (res) => {
    if (res.ok) {
      res.json().then(this.handleData);
    }
  }

  handleData = (data) => {
    const country = data.payload.country;
    const state = data.payload.state;
    const center = data.payload.center;

    if (state) {
      this.props.updater.emit(
        STATE_SET,
        { long_name: state.long_name, short_name: state.short_name }
      );
    }

    if (country) {
      this.props.updater.emit(
        COUNTRY_SET,
        { long_name: country.long_name, short_name: country.short_name }
      );
    }

    if (state) {
      this.props.updater.emit(
        CENTER_SET,
        { lat: center.lat, lng: center.lng }
      );
    }
  }

  render() {
    return (
      (<li ref="li" onClick={this.handleClick}>
        {this.props.description}
      </li>)
    );
  }
}
